/* eslint-disable react-hooks/exhaustive-deps */
import { PlusCircleOutlined } from '@ant-design/icons';
import { Affix, Button, Divider, Form, Input, Select, Space } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import parse from 'html-react-parser';
import DataFlowService from '../../../../services/DataFlow.service';
import { tab3Render } from '../../../../util/tagRender';
import useNotify from '../../../../context/Notification/useNotify';
import { useBlocker } from '../../../../util/usePrompt';
import ModalDiscardChanges from '../../../../components/Shared/modal/discardChanges';
import ModalConfirm from '../../../../components/Shared/modal/confirm';
import { ROUTER } from '../../../../constants/router';

const { Option } = Select;
const { TextArea } = Input;

export default function Tab3({ referenceDocuments, getDataFlowDetail }) {
    const [form] = Form.useForm();
    const { t, i18n } = useTranslation();
    const { businessProcessId } = useParams();
    const navigate = useNavigate();
    const notify = useNotify();

    const [items, setItems] = useState([]);
    const [nameInput, setName] = useState('');
    const [hasFeedback, setHasFeedback] = useState(false);

    // Confirm
    const [openConfirm, setOpenConfirm] = useState(false);
    const [valueSave, setValueSave] = useState();
    const [loading, setLoading] = useState(false);

    // Discard change
    const [change, setChange] = useState(false);
    const [openChange, setOpenChange] = useState(false);
    const [nextLocation, setNextLocation] = useState(null);
    const [isChangeLocation, setIsChangeLocation] = useState(false);

    useBlocker((nextLocation) => onChangePage(nextLocation), change === true);

    const onChangePage = (nextLocation) => {
        setOpenChange(true);
        setIsChangeLocation(true);
        setNextLocation(nextLocation);
    };

    const handelOk = async () => {
        setOpenChange(false);
        setChange(false);
    };

    const handelOkLocation = async () => {
        setOpenChange(false);
        setChange(false);
        setIsChangeLocation(false);
        await form.resetFields();
        await navigate(
            nextLocation.location.pathname + nextLocation.location.search
        );
        await getDataFlowDetail(businessProcessId);
    };

    const changePage = () => {
        navigate(
            `${ROUTER.DS_INVENTORY.DATAFLOW}/${businessProcessId}/view?tab=3&mode=view`
        );
    };

    // Discard change end
    const [buttonStatus, setButtonStatus] = useState(true);
    const onNameChange = (event) => {
        setName(event.target.value.trim());
        if (event.target.value.trim()) {
            setButtonStatus(false);
        } else {
            setButtonStatus(true);
        }
    };

    const addItem = (e) => {
        e.preventDefault();
        if (nameInput) {
            addDocumentType({
                name: nameInput,
            });
        }
    };

    const onFinish = () => {
        createRefDocument({
            businessProcessId,
            ...valueSave,
        });
    };

    const getMasterDocumentType = async () => {
        try {
            const { data } = await DataFlowService.getMasterDocumentType();
            if (data?.resultData) {
                const items = [];
                for (let item of data?.resultData) {
                    items.push({
                        id: item.statusId,
                        ...item,
                    });
                }
                setItems(items);
                setHasFeedback(false);
                setName('');
            }
        } catch (error) {
            setHasFeedback(false);
            console.log(error);
        }
    };

    const addDocumentType = async (payload) => {
        try {
            const { data } = await DataFlowService.addDocumentType(payload);
            if (data?.resultCode === 1) {
                setHasFeedback(true);
                setTimeout(() => {
                    getMasterDocumentType();
                }, 1000);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const createRefDocument = async (payload) => {
        setLoading(true);
        try {
            const { data } = await DataFlowService.updateRefDocument(payload);
            if (data?.resultCode === 1) {
                notify({
                    title: t('common.Success'),
                    description: t('common.SaveData'),
                });
                setOpenChange(false);
                setChange(false);
                getDataFlowDetail(businessProcessId);
                setLoading(false);
                setOpenConfirm(false);
                changePage();
            }
        } catch (error) {
            setLoading(false);
            console.log(error);
            notify({
                type: 'error',
                title: t('common.Fail'),
                description: t('Failed to submitted'),
            });
            setOpenConfirm(false);
        }
    };

    useEffect(() => {
        if (referenceDocuments) {
            let referenceDocuments__ = [];
            for (let ref of referenceDocuments) {
                referenceDocuments__.push({
                    documentTypes: ref?.documentTypes?.map((d) => d.id),
                    name: ref.name,
                    referenceDocumentId: ref.referenceDocumentId,
                    storagePeriod: ref.storagePeriod,
                });
            }
            const referenceDocuments_ =
                referenceDocuments?.length > 0
                    ? referenceDocuments__
                    : [
                          {
                              name: '',
                              documentTypes: [],
                          },
                      ];
            form.setFieldsValue({
                referenceDocuments: referenceDocuments_,
            });
        }
    }, [referenceDocuments]);

    useEffect(() => {
        getMasterDocumentType();
    }, []);
    return (
        <div className="w-full">
            <Form
                scrollToFirstError={{
                    behavior: 'smooth',
                    block: 'center',
                }}
                layout="vertical"
                form={form}
                onFinish={(value) => {
                    setOpenConfirm(true);
                    setValueSave(value);
                }}
                onFieldsChange={(_, allFields) => {
                    if (allFields.length > 0) {
                        setChange(true);
                    }
                }}
            >
                <Affix offsetTop={60}>
                    <div className="flex justify-end space-x-3">
                        <Button
                            hidden={referenceDocuments?.length === 0}
                            size="large"
                            type="default"
                            className="text-purple-PHX border-purple-PHX w-32"
                            onClick={changePage}
                        >
                            {t('common.Cancel')}
                        </Button>
                        <Button
                            size="large"
                            type="primary"
                            className="w-32"
                            htmlType="submit"
                        >
                            {t('common.Save')}
                        </Button>
                    </div>
                </Affix>
                <span className="ant-col ant-form-item-label">
                    <label className="ant-form-item-required">
                        <span className="text-[21px] font-bold">
                            {t('dataFlow.references')}
                        </span>
                    </label>
                </span>
                <div className="col-span-2 font-medium pb-4">
                    {parse(t('Dataflow Tab3'))}
                </div>

                <Form.Item
                    name="referenceDocuments"
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                >
                    <Form.List name="referenceDocuments">
                        {(fields, { add, remove }) => (
                            <div className="space-y-4">
                                {fields.map(
                                    ({ key, name, ...restField }, i) => (
                                        <div key={key} className="flex gap-4">
                                            <div className="p-4 rounded-md bg-[#EDEEF9] w-full delay-500 transition-all">
                                                <Form.Item
                                                    className="w-full"
                                                    {...restField}
                                                    name={[name, 'name']}
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: t(
                                                                'errorText.requiredField'
                                                            ),
                                                        },
                                                    ]}
                                                    label={t(
                                                        'Document/File Name'
                                                    )}
                                                >
                                                    <TextArea
                                                        placeholder={t(
                                                            'dataFlow.pleaseSpecifyDocument'
                                                        )}
                                                        size="large"
                                                        maxLength={255}
                                                        showCount
                                                        className="bg-white_text_input"
                                                        autoSize={{
                                                            minRows: 4,
                                                            maxRows: 6,
                                                        }}
                                                    />
                                                </Form.Item>
                                                <Form.Item
                                                    className="w-full"
                                                    {...restField}
                                                    name={[
                                                        name,
                                                        'documentTypes',
                                                    ]}
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: t(
                                                                'errorText.requiredField'
                                                            ),
                                                        },
                                                        {
                                                            type: 'array',
                                                            max: 10,
                                                            message: t(
                                                                'dataFlow.DocumentLimit'
                                                            ),
                                                        },
                                                    ]}
                                                    hasFeedback={hasFeedback}
                                                    validateStatus="validating"
                                                    label={t(
                                                        'Document type/File extension'
                                                    )}
                                                >
                                                    <Select
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                        placeholder={t(
                                                            'dataFlow.ChooseDocumentFormat'
                                                        )}
                                                        mode="tags"
                                                        size="large"
                                                        tagRender={tab3Render}
                                                        placement="bottomRight"
                                                        maxTagCount="responsive"
                                                        className="tab3 bg-white_text_input"
                                                        dropdownMatchSelectWidth={
                                                            300
                                                        }
                                                        showArrow
                                                        dropdownRender={(
                                                            ...menu
                                                        ) => (
                                                            <>
                                                                {menu}
                                                                <Divider
                                                                    style={{
                                                                        margin: '8px 0',
                                                                    }}
                                                                />
                                                                <Space
                                                                    align="center"
                                                                    style={{
                                                                        padding:
                                                                            '0 8px 4px',
                                                                    }}
                                                                >
                                                                    <Input
                                                                        type="text"
                                                                        id="input"
                                                                        name="input"
                                                                        size="large"
                                                                        placeholder={t(
                                                                            'dataFlow.CreateNew'
                                                                        )}
                                                                        value={
                                                                            nameInput
                                                                        }
                                                                        onChange={(
                                                                            e
                                                                        ) => {
                                                                            onNameChange(
                                                                                e
                                                                            );
                                                                        }}
                                                                    />
                                                                    <Button
                                                                        size="large"
                                                                        type="primary"
                                                                        onClick={
                                                                            addItem
                                                                        }
                                                                        disabled={
                                                                            buttonStatus
                                                                        }
                                                                    >
                                                                        {t(
                                                                            'dataFlow.CreateNew'
                                                                        )}
                                                                    </Button>
                                                                </Space>
                                                            </>
                                                        )}
                                                    >
                                                        {items.map((item) => (
                                                            <Option
                                                                key={item.id}
                                                                value={item.id}
                                                            >
                                                                {i18n.language ===
                                                                'en'
                                                                    ? item.nameEn
                                                                    : item.nameTh}
                                                            </Option>
                                                        ))}
                                                    </Select>
                                                </Form.Item>
                                                <Form.Item
                                                    label={t('Storage period')}
                                                    className="w-full"
                                                    {...restField}
                                                    name={[
                                                        name,
                                                        'storagePeriod',
                                                    ]}
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: t(
                                                                'errorText.requiredField'
                                                            ),
                                                        },
                                                    ]}
                                                >
                                                    <TextArea
                                                        placeholder={t(
                                                            'dataFlow.PleaseSpecifyStoragePeriod'
                                                        )}
                                                        size="large"
                                                        maxLength={255}
                                                        showCount
                                                        autoSize={{
                                                            minRows: 4,
                                                            maxRows: 6,
                                                        }}
                                                        className="bg-white_text_input"
                                                    />
                                                </Form.Item>
                                            </div>
                                            <Button
                                                hidden={fields.length <= 1}
                                                className="bg-[#F3F6F9] p-0 border-none"
                                                onClick={() => remove(name)}
                                                icon={<DeleteIcon />}
                                            ></Button>
                                        </div>
                                    )
                                )}
                                {fields.length < 20 && (
                                    <Form.Item className="mb-0">
                                        <span
                                            className="text-blue-400 hover:opacity-80 cursor-pointer font-semibold"
                                            onClick={() => add()}
                                        >
                                            <PlusCircleOutlined />{' '}
                                            {t('common.addOption')}
                                        </span>
                                    </Form.Item>
                                )}
                            </div>
                        )}
                    </Form.List>
                </Form.Item>
            </Form>
            <ModalDiscardChanges
                open={openChange}
                handelOk={isChangeLocation ? handelOkLocation : handelOk}
                handelClose={() => setOpenChange(false)}
            />
            <ModalConfirm
                loading={loading}
                text={t('Do you want to confirm')}
                open={openConfirm}
                handelOk={onFinish}
                handelClose={() => setOpenConfirm(false)}
            />
        </div>
    );
}

export const DeleteIcon = () => (
    <svg
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
        className="mt-1"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M8 0.25C8.68613 0.249903 9.34752 0.506305 9.85429 0.96886C10.3611 1.43142 10.6766 2.06671 10.739 2.75H15C15.19 2.75006 15.3729 2.82224 15.5118 2.95197C15.6506 3.0817 15.7351 3.2593 15.748 3.44888C15.761 3.63846 15.7015 3.82589 15.5816 3.9733C15.4616 4.12071 15.2902 4.2171 15.102 4.243L15 4.25H14.417L13.15 15.23C13.0936 15.7174 12.86 16.167 12.4936 16.4934C12.1272 16.8198 11.6537 17.0001 11.163 17H4.837C4.34635 17.0001 3.87279 16.8198 3.50642 16.4934C3.14005 16.167 2.90642 15.7174 2.85 15.23L1.582 4.25H1C0.818762 4.24999 0.643658 4.18436 0.507069 4.06523C0.370481 3.94611 0.281648 3.78155 0.257 3.602L0.25 3.5C0.250008 3.31876 0.315643 3.14366 0.434767 3.00707C0.553891 2.87048 0.718446 2.78165 0.898 2.757L1 2.75H5.261C5.32338 2.06671 5.63893 1.43142 6.14571 0.96886C6.65248 0.506305 7.31387 0.249903 8 0.25ZM6.5 6.5C6.255 6.5 6.05 6.655 6.008 6.859L6 6.938V13.063L6.008 13.141C6.05 13.345 6.255 13.5 6.5 13.5C6.745 13.5 6.95 13.345 6.992 13.141L7 13.062V6.939L6.992 6.859C6.95 6.656 6.745 6.5 6.5 6.5ZM9.5 6.5C9.255 6.5 9.05 6.655 9.008 6.859L9 6.938V13.063L9.008 13.141C9.05 13.345 9.255 13.5 9.5 13.5C9.745 13.5 9.95 13.345 9.992 13.141L10 13.062V6.939L9.992 6.859C9.95 6.656 9.745 6.5 9.5 6.5ZM8 1.75C7.395 1.75 6.89 2.18 6.775 2.75H9.225C9.109 2.18 8.605 1.75 8 1.75Z"
            fill="#7B67FB"
        />
    </svg>
);
